export default __webpack_public_path__ + "static/media/gym-img-05.30df0eed.jpg";